<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 2l-5.5 9h11z" :fill="$vuetify.theme.dark ? '#CECECE' : '#231815'"/>
        <circle cx="17.5" cy="17.5" r="4.5" :fill="$vuetify.theme.dark ? '#CECECE' : '#231815'"/>
        <path d="M3 13.5h8v8H3z" :fill="$vuetify.theme.dark ? '#CECECE' : '#231815'"/>
    </svg>
</template>

<script>
export default {
  name: 'Category'
}
</script>

<style scoped>
    svg {
        width:24px;
        height: 24px;
    }
</style>